import React from 'react';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import '../../../../components/clients/mobile/styles/MobileClients.css';

const roleSortOrder = ['all', 'owner', 'manager', 'employee'];

/**
 * Bottom sheets for role filter + sort — same visuals as mobile clients.
 */
export default function EmployeeMobileFilterDrawers({
  filterOpen,
  onCloseFilter,
  sortOpen,
  onCloseSort,
  roles = [],
  selectedRoleId = 'all',
  onRoleSelect,
  sortBy,
  sortDirection,
  onSortChange,
}) {
  const sortedRoles = [...roles].sort(
    (a, b) =>
      (roleSortOrder.indexOf(a.id) === -1 ? 99 : roleSortOrder.indexOf(a.id)) -
      (roleSortOrder.indexOf(b.id) === -1 ? 99 : roleSortOrder.indexOf(b.id)),
  );

  return (
    <>
      <div
        className={
          'mobile-clients-drawer-backdrop' + (filterOpen ? ' mobile-clients-drawer-backdrop--open' : '')
        }
        onClick={onCloseFilter}
        aria-hidden={!filterOpen}
      />
      <div
        className={'mobile-clients-drawer' + (filterOpen ? ' mobile-clients-drawer--open' : '')}
        aria-hidden={!filterOpen}
      >
        <div className="mobile-clients-drawer-header">
          <h3 className="mobile-clients-drawer-title">Filter team</h3>
          <button
            type="button"
            className="mobile-clients-drawer-close"
            onClick={onCloseFilter}
            aria-label="Close filters"
          >
            <MoreVertIcon />
          </button>
        </div>
        <p className="mobile-employees-drawer-section-label">Roles</p>
        <div className="mobile-clients-chip-row employee-role-chip-row">
          {sortedRoles.map((role) => {
            const isActive = selectedRoleId === role.id;
            return (
              <button
                key={role.id}
                type="button"
                className={'mobile-clients-chip' + (isActive ? ' mobile-clients-chip--active' : '')}
                onClick={() => {
                  onRoleSelect(role.id);
                  onCloseFilter();
                }}
              >
                {role.label} ({role.count})
              </button>
            );
          })}
        </div>
        {selectedRoleId !== 'all' ? (
          <button
            type="button"
            className="mobile-clients-primary-button"
            onClick={() => {
              onRoleSelect('all');
              onCloseFilter();
            }}
          >
            Clear filters
          </button>
        ) : null}
      </div>

      <div
        className={
          'mobile-clients-drawer-backdrop' + (sortOpen ? ' mobile-clients-drawer-backdrop--open' : '')
        }
        onClick={onCloseSort}
        aria-hidden={!sortOpen}
      />
      <div
        className={'mobile-clients-drawer' + (sortOpen ? ' mobile-clients-drawer--open' : '')}
        aria-hidden={!sortOpen}
      >
        <div className="mobile-clients-drawer-header">
          <h3 className="mobile-clients-drawer-title">Sort team</h3>
          <button
            type="button"
            className="mobile-clients-drawer-close"
            onClick={onCloseSort}
            aria-label="Close sort"
          >
            <MoreVertIcon />
          </button>
        </div>
        <button
          type="button"
          className="mobile-clients-outline-button"
          onClick={() => onSortChange('name')}
        >
          Sort by name {sortBy === 'name' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
        </button>
        <button
          type="button"
          className="mobile-clients-outline-button"
          onClick={() => onSortChange('role')}
        >
          Sort by role {sortBy === 'role' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
        </button>
        <button
          type="button"
          className="mobile-clients-outline-button"
          onClick={() => onSortChange('date')}
        >
          Sort by join date {sortBy === 'date' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
        </button>
      </div>
    </>
  );
}
